export const deleteCollectionApiUrls = {
	deleteCollection: 'collections/:collectionId',
};
